import axios from 'axios'
import { baseURL } from '@/common/config/config.js'
const service = axios.create({
  baseURL: baseURL
})
export default service
